import { VatModelType } from '@teinor/erp/types/company/vat'
import { useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { getDictionaryCountries } from '../../../../../../utils/reducers/getters'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalDeleteSingleVat from './DeleteModalSingleVat'
import ModalCESingleVat from './ModalCESingleVat'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderCountryName, CustomRenderStateName, CustomRenderString, DeleteRow, EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'

interface ConfigSingleVatProps extends ComponentWithPermissions { }

const ConfigSingleVat: React.FC<ConfigSingleVatProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('zonesInnerGroupVat', 'Zonas del grupo de impuestos'),
        newText: t('createNewZone', 'Crear nueva zona')
    }

    return (
        <BaseScreenTable TableComponent={ConfigSingleVatTable} CreateModalComponent={ModalCESingleVat} EditModalComponent={ModalCESingleVat} pageData={pageData} DeleteModalComponent={ModalDeleteSingleVat} userPermissions={userPermissions} />
    )
}

interface ConfigSingleVatTableProps extends TableComponentProps { }

const ConfigSingleVatTable: React.FC<ConfigSingleVatTableProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { GroupVatId } = useParams()
    const countries = getDictionaryCountries()
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<VatModelType> = [
        {
            id: 'country',
            dataKey: 'country',
            label: t('country', 'País'),
            customRender: (parameterValue) => <CustomRenderCountryName countryId={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: countries, label: t('country', 'País') }
            },
            generalSearchable: false
        },
        {
            id: 'state',
            dataKey: 'state',
            label: t('state', 'Provincia'),
            customRender: (parameterValue, allRowData) => <CustomRenderStateName stateId={parameterValue} allRowData={allRowData} />,
        },
        {
            id: 'vat',
            dataKey: 'vat',
            label: t('vat', 'Impuesto'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue + ' %'} />,
            sortable: true
        },
        {
            id: 'vat2',
            dataKey: 'vat2',
            label: t('vat2', 'Impuesto secundario'),
            customRender: (parameterValue) => <CustomRenderString value={(parameterValue || 0) + ' %'} />,
        },
        {
            id: 'edit',
            dataKey: 'country',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'country',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='vats' columns={columns} getDataFrom='/api/app/config/vat/getAllVats' defaultOrder={{ defaultOrderField: 'GroupVatId' }} setTableInstance={setTableInstance} extraWhereParams={{ GroupVatId }} onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })}
        />
    )
}


export default ConfigSingleVat